import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import values from 'lodash/values';

import { stringSelectSpec } from '../../lib/editing-configs';

import BackgroundColor from '../background-color/background-color';
import './vertical-spacer.less';

const spacerMap = {
  'p-8': 'p-8',
  'p-12': 'p-12',
  'p-18': 'p-18',
  'p-24': 'p-24',
  'p-30': 'p-30',
  'p-40': 'p-40',
  'p-60': 'p-60',
};

const VerticalSpacer = ({
  desktop,
  tablet,
  mobile,
  bgOptions,
  backgroundColor: obsoleteBackgroundColor,
}) => {
  function getBackgroundColorConfig() {
    // For backwards compatibility!
    if (obsoleteBackgroundColor && !bgOptions?.backgroundColor) {
      return { backgroundColor: obsoleteBackgroundColor };
    }
    return bgOptions;
  }
  return (
    <BackgroundColor bgOptions={getBackgroundColorConfig()}>
      {(backgroundColor) => (
        <div
          className={classNames({
            [`${spacerMap[desktop]}-d`]: desktop,
            [`${spacerMap[tablet]}-t`]: tablet,
            [`${spacerMap[mobile]}-m`]: mobile,
          })}
          style={{ backgroundColor }}
        />
      )}
    </BackgroundColor>
  );
};

VerticalSpacer.propTypes = {
  ...BackgroundColor.propTypes,
  desktop: PropTypes.oneOf(values(spacerMap)),
  tablet: PropTypes.oneOf(values(spacerMap)),
  mobile: PropTypes.oneOf(values(spacerMap)),
};

const spacerOptions = [{ label: 'Select one', value: '' }].concat(
  Object.keys(spacerMap).map((key) => ({
    label: key,
    value: spacerMap[key],
  }))
);

VerticalSpacer.getEditingConfig = (componentDocument) => {
  return [
    ...BackgroundColor.getEditingConfig(componentDocument),
    stringSelectSpec('mobile', 'Mobile', spacerOptions, {
      help: 'Mobile height',
    }),
    stringSelectSpec('tablet', 'Tablet', spacerOptions, {
      help: 'Tablet height',
    }),
    stringSelectSpec('desktop', 'Desktop', spacerOptions, {
      help: 'Desktop height',
    }),
  ];
};

export default VerticalSpacer;
